import {
  Component,
  OnInit,
  Injector,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy
} from "@angular/core";
import { GenericBasicGUI } from "src/model/class/component classes/generic-basic-gui";

import { DomSanitizer } from "@angular/platform-browser";

@Component({
    selector: "app-vlc-camera",
    templateUrl: "./vlc-camera.component.html",
    styleUrls: ["./vlc-camera.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VlcCameraComponent extends GenericBasicGUI implements OnInit {
  public videoUrl: any = null;
  public styles = {};
  public stylesChild = {};

  public idCustomInterfaceComponent: number = 0;

  /**
   * Giorgia -
   * @param injector The injector param is used by the parent classes to inject the services that they needed:
   * using this trick if the parent classes needed some specific service I don't need to inject them here
   * but I can do the injection in the specific class.
   */
  constructor(injector: Injector, private _domSanitizer: DomSanitizer) {
    super(injector);
  }

  ngOnInit() {
    this.idCustomInterfaceComponent = this.ComponentAPI.id;
    [this.styles, this.stylesChild] = super.HandleProperties(
      this.styles,
      this.stylesChild
    );

    this.videoUrl = this.ComponentAPI.properties["URL"];

    if (!this.ShowingInDesktopVersion) {
      this.styles["width"] =
        Math.min(
          this.platform.width(),
          parseInt(this.styles["width"].replace("px", ""))
        ) + "px";
    }
  }

  ngOnDestroy() {
    this.onDestroyChildren();
  }
}
